import React from 'react';
import SalaryCounter from './components/SalaryCounter';
import './App.css';

function App() {
  return (
    <div className="App">
      <SalaryCounter />
    </div>
  );
}

export default App; 